<template>
  <div>
    <LogsHighlight :logs="filteredLogs" />
    <v-card class="rounded-lg pt-3 mt-6">
      <v-row class="mx-2" no-gutters>
        <v-col cols="12" md="8" class="pa-2 py-1">
          <ClientSelect
            v-model="selectedClient"
            label="Buscar por cliente"
            clearable
            dense
            :disabled="loading"
          />
        </v-col>
        <v-col cols="12" md="4" class="pa-2 py-1">
          <div class="d-flex gap-2 align-center h-100">
            <div class="flex-grow-1">
              <DateRangePicker
                v-model="dateRange"
                color="secondary"
                block
                :disabled="loading"
                outlined
                dense
              />
            </div>
            <v-btn
              class="flex-shrink-0 flex-grow-0"
              color="primary"
              @click="loadMore"
              :loading="loading"
              depressed
            >
              Buscar
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <v-data-table
        :items="filteredLogs"
        :headers="headers"
        dense
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [50, 100, 200],
        }"
      >
        <template v-slot:item.eventDate="{ item }">
          {{ item.eventDate | date("DD/MM/YYYY HH:mm") }}
        </template>
        <template v-slot:item.client="{ item }">
          <span v-if="item.accessId">
            {{
              item.client?.name ||
              `Usuário desconhecido: #${item.accessId} • ${item.clientName || 'Sem nome'}`
            }}
          </span>
        </template>
        <template v-slot:item.type="{ item }">
          <v-chip
            :color="types[item.type].color"
            small
            label
            style="width: 120px; text-align: center"
          >
            <span :style="{ width: '110px', textAlign: 'center' }">{{
              types[item.type].label
            }}</span>
          </v-chip>
        </template>
        <template v-slot:item.file="{ item }">
          <v-tooltip v-if="item.file" top class="pa-0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="openImageViewer(item.file)"
              >
                <v-icon>mdi-file-image</v-icon>
              </v-btn>
            </template>
            <v-img
              :src="item.file"
              :width="(100 * 16) / 10"
              height="100"
              contain
            />
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import dayjs from "dayjs";
import ClientSelect from "@/components/store/ClientSelect.vue";
import DateRangePicker from "../../components/global/DateRangePicker.vue";
import LogsHighlight from "./LogsHighlight.vue";
export default {
  name: "TableLogs",
  components: {
    ClientSelect,
    DateRangePicker,
    LogsHighlight,
  },
  emits: ["input", "change", "loadMore"],
  props: {
    logs: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    fullLoaded: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    dateRange: {
      start: dayjs().startOf("month").format("YYYY-MM-DD"),
      end: dayjs().endOf("month").format("YYYY-MM-DD"),
    },
    search: "",
    innerLoading: false,
    selectedClient: null,
    headers: [
      { text: "Data", value: "eventDate" },
      { text: "Cliente", value: "client" },
      { text: "Tipo", value: "type" },
      { text: "Mensagem", value: "message" },
      { text: "Arquivo", value: "file" },
    ],
    types: {
      ACCESS: {
        label: "Acesso",
        color: "success",
      },
      ACCESS_DENIED: {
        label: "Acesso negado",
        color: "error",
      },
      DOOR_OPEN: {
        label: "Porta aberta",
        color: "info",
      },
      DOOR_CLOSE: {
        label: "Porta fechada",
        color: "info",
      },
      OTHER: {
        label: "Outro",
        color: "grey",
      },
    },
  }),
  computed: {
    filteredLogs() {
      return this.logs.filter((log) => {
        // client
        if (
          this.selectedClient?.accessId &&
          log.accessId !== this.selectedClient.accessId
        )
          return false;

        // start date
        if (
          this.dateRange.start &&
          dayjs(log.eventDate).isBefore(
            dayjs(this.dateRange.start).startOf("day")
          )
        )
          return false;

        // end date
        if (
          this.dateRange.end &&
          dayjs(log.eventDate).isAfter(dayjs(this.dateRange.end).endOf("day"))
        )
          return false;

        return true;
      });
    },
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const query = queryText.toString().toLowerCase();

      const { name, accessId } = item;

      return (
        name.toLowerCase().indexOf(query) > -1 ||
        accessId.toString().indexOf(query) > -1
      );
    },
    openImageViewer(src) {
      this.$root.$emit("imageViewer", src);
    },
    loadMore() {
      this.$emit("loadMore", {
        start: this.dateRange.start,
        end: this.dateRange.end,
      });
    },
  },
  watch: {
    dateRange: {
      handler(val, oldVal) {
        if (val.start === oldVal.start && val.end === oldVal.end) return;
        this.loadMore();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadMore();
  },
};
</script>
